import HistoryTabsComponent from "../../components/history/HistoryTabsComponent.jsx";
import {connect} from "react-redux";
import {createLocalization} from "../../../common/util/localization.jsx";
import {scssVariables} from "../../../common/util/config.jsx";

const mapStateToProps = state => ({
    deviceType: state.view.deviceType,
    height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
    localization: createLocalization(state),
    webEditOnlyTobacco : state.authentication.webEditOnlyTobacco,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryTabsComponent);